import { FC } from 'react';
import { Resizable, ResizableProps } from 'react-resizable';

export const ResizableTableHeader: FC<ResizableProps> = props => {
  const { onResize, width, ...restProps } = props;

  if (!width) {
    return <th {...restProps} />;
  }
  return (
    <Resizable
      width={width}
      height={0}
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} />
    </Resizable>
  );
};
